var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUnhighlight = function SvgUnhighlight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8125 26.0875L22.875 23.15L15 15.2875L10.55 10.825L8.775 9.06252L5.3375 5.62502L3.75 7.21252L7.225 10.6875C4.0375 14.6125 4.275 20.3875 7.925 24.05C9.875 26 12.4375 26.975 15 26.975C17.2375 26.975 19.4625 26.2375 21.2875 24.75L24.6625 28.125L26.25 26.5375L25.8125 26.0875ZM15 24.4875C13 24.4875 11.1125 23.7125 9.7 22.2875C8.275 20.8625 7.5 18.9875 7.5 16.9875C7.5 15.3375 8.0375 13.775 9.0125 12.4875L15 18.4625V24.4875ZM15 6.37502V12.1L24.0625 21.175C25.775 17.475 25.1125 12.9625 22.0625 9.91252L15 2.83752L10.375 7.46252L12.1375 9.22502L15 6.37502Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUnhighlight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/unhighlight.fec67199.svg";
export { ForwardRef as ReactComponent };